// extracted by mini-css-extract-plugin
export default {"wrap":"DataTable__wrap__pwkWR","skeleton":"DataTable__skeleton__EJAbx","row":"DataTable__row__zS_nc","clickable":"DataTable__clickable__NmVJz"};